import { Row } from '@shipt/design-system-layouts'
import styled from 'styled-components'

export const MobileAddressWrapper = styled(Row)<{
  isPastScrollThreshold: boolean
}>`
  position: absolute;
  bottom: -0.5rem;
  left: 1rem;
  right: 1rem;
  width: auto;
  transition: opacity 0.3s ${({ isPastScrollThreshold }) => (isPastScrollThreshold ? '' : '0.3s')}
    ease;
  opacity: ${({ isPastScrollThreshold }) => (isPastScrollThreshold ? 0 : 1)};
`
